import { render } from "./PopupAddSalary.vue?vue&type=template&id=3aa7e55c&scoped=true"
import script from "./PopupAddSalary.vue?vue&type=script&lang=js"
export * from "./PopupAddSalary.vue?vue&type=script&lang=js"

import "./PopupAddSalary.vue?vue&type=style&index=0&id=3aa7e55c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa7e55c"]])

export default __exports__